import { ReactNode } from 'react';
import { INavItemData } from '@/creditflowresearch/ui/common/constants/panelData';
import PanelTools from '@/creditflowresearch/ui/common/components/organisms/PanelTools';
import { PanelLayoutMobile } from '@/creditflowresearch/ui/common/components/templates/PanelLayout';
import { SectionLayoutMobile } from '@/creditflowresearch/ui/common/components/templates/SectionLayout';
import { IToolLinkOption } from '@/creditflowresearch/domain/vo/ITools';
import { ISection } from '@creditflowresearch/uilib/Section';

interface IPanelTemplateMobileProps {
  panelData: INavItemData,
  headerPanel: ReactNode,
  topOptions: IToolLinkOption[],
  toolsOptions: IToolLinkOption[],
  sectionsGrid: ISection[][][],
}

const PanelTemplateMobile = ({
  panelData,
  headerPanel,
  topOptions,
  toolsOptions,
  sectionsGrid,
}: IPanelTemplateMobileProps) => (
  <PanelLayoutMobile
    headerPanel={ headerPanel }
    topContent={ (
      <PanelTools
        topOptions={ topOptions }
        toolsOptions={ toolsOptions }
        title={ `Tools (${ panelData.abbreviation })` }
      />
    ) }
    bottomContent={ (
      <SectionLayoutMobile
        title={ panelData.sectionsTitle }
        sectionsGrid={ sectionsGrid }
      />
    ) }
  />
);

export default PanelTemplateMobile;
